module.exports = __webpack_public_path__ + "img/sert2.4785c14d.jpg";